import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c(VAlert,{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.error))]):_c('div',[(!_vm.barcodeScanner)?_c(VAlert,{attrs:{"type":"info"}},[_vm._v("Initializing...")]):_vm._e(),_c(VContainer,{ref:"container",staticClass:"pa-0 scanner"},[_c('div',{staticClass:"dce-video-container",staticStyle:{"width":"100%","height":"70vh"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }